import { Component, OnInit, inject } from '@angular/core';
import { ApplicationHttpService } from '../../../../core/services/application-http.service';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-reassign-action-modal',
    templateUrl: './reassign-action-modal.component.html',
    styleUrls: ['./reassign-action-modal.component.scss'],
    standalone: false
})
export class ReAssignActionModalComponent implements OnInit {

  /** `postReg: true` loads CASE_OFFICER_POSTREG users; registration opens the modal without data. */
  private readonly modalData = inject<{ postReg?: boolean } | null>(NZ_MODAL_DATA, { optional: true });

  caseOfficers: any[] = [];

  selectedCaseOfficer: any;

  isLoading: boolean = false;

  //@ts-ignore
  reason: string;

  ngOnInit(): void {
    this.caseOfficers = [
      {id: 1, value: "Naruto Uzumaki1"},
      {id: 2, value: "Naruto Uzumaki2"},
      {id: 3, value: "Naruto Uzumaki3"},
      {id: 4, value: "Naruto Uzumaki4"}
    ];
  }

  constructor(public modal: NzModalRef<ReAssignActionModalComponent>,
    private http: ApplicationHttpService
  ) {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    const url = this.modalData?.postReg
      ? 'available-employee/post-reg-case-officer/all'
      : 'available-employee/case-officer/all';
    this.http.get<any[]>(url, null).subscribe({
      next: resp => {
        this.caseOfficers = resp;
        this.isLoading = false;
      },
      error: () => this.isLoading = false
    });
  }

  cancel() {
    this.modal.close(null);
  }

  confirm() {
    this.modal.close({reason: this.reason, username: this.selectedCaseOfficer.username});
  }

  onChooseOfficer(item: any) {
    this.selectedCaseOfficer = item;
  }
}
